import { css } from '@emotion/css'
import { breakpoint, fontWeight, spacing, mediaQueryHelper } from '@offerzen/pinata-shame'

const styles = {
  statusRadio: css({
    width: '100%',
  }),

  workPermitSection: css({
    marginTop: 0,
  }),

  workPermitSectionField: css({
    div: {
      input: {
        height: 38,
        border: 'none',
      },
    },
    width: '100%',
    marginBottom: spacing.medium,
  }),

  citizenshipStatus: css({
    legend: {
      fontWeight: fontWeight.default,
    },
  }),

  button: css({
    [mediaQueryHelper(breakpoint.phone)]: {
      marginLeft: spacing.default,
    },

    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      marginTop: spacing.default,
    },
  }),

  buttonContainer: css({
    marginBottom: spacing.medium,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: 'auto',
  }),
}

export default styles
